import React, { useEffect, useState, Fragment } from 'react';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react';
import { Button } from '@mui/material';
import { styled } from '@mui/system';
import { isEmpty, isNumber } from 'lodash';
import { round } from 'mathjs';

import '../../scss/public.scss';
import './scss/index.scss';
import Color from '@tool/color';
import SubTitle from '../../component/sub-title';
import Tab from '../../component/tab';
import TimeTab from '../../component/time-tab';
import moSettleCompare, {
  changeType, timeTabChange,
} from './store/index';
import Left from './left';
import IncomeRight from '../../component/income-right';
import CommonTable from '../../component/common-table';
import Empty from '@/component/empty';
import moEffect from '../../store/index';
import { newRate } from '@tool/index';
import MainTitle from '../../component/main-title';
import moEffectPdf from '../../store/index';

interface IProps {
  data: any,
}
interface IState { }

const IndustryCompare = (props: IProps, state: IState) => {
  const navi = useNavigate();
  const {
    type, empty, timeList, timeActive,
    tableTitle, tableList, desc, overview,
    leftXData, leftYData, rightXData, rightYData,
  } = moSettleCompare;
  const { data } = props;
  const { yearList } = moEffect;

  useEffect(() => {
    return () => { };
  }, []);

  return (
    <section id="effect11" className="industry-compare_10 box-111 human-common-pdf"
      style={{ marginTop: '0', borderRadius: '0 0 20px 20px' }}>
      <MainTitle
        title='行业对比'
        subtitle='多行业比对'
        year={data.kt}
        bgcolor={Color.secondaryColor(0.1)}
        color={Color.secondary} />

      <section className="content-1015">
        {!empty ? (
          <>
            <section className="content-1030">
              <section className="left-1011">
                <p className="line-1011"><strong>人员规模</strong></p>
                <Left height={300} xData={leftXData} yData={leftYData} name={timeActive} />
              </section>
              <section className="right-1011">
                <p className="line-1011"><strong>变化率(%)</strong></p>
                <IncomeRight height={300} xData={rightXData} yData={rightYData} name={timeActive} />
              </section>
            </section>
          </>
        ) : <Empty />}
      </section>

      {!isEmpty(overview) && <section className="chart-detail industry-detail">
        <section>注：</section>
        {
          overview?.map((res: any, r: any) => {
            return <section className='item' key={`${r}`}>
              <b />
              <p >
                {res.map((ele: any, e: any) => {
                  return <span className={ele.mark} key={`${e}l`}>
                    {isNumber(ele.value) ? (ele.mark === 'change_ratio' ? `${round(ele.value * 100, 1)}%` : round(ele.value, 1)) : ele.value}
                  </span>;
                })}
              </p>
            </section>;
          })}
      </section>}
    </section>
  );
};

export default observer(IndustryCompare);
